import ScopeChangeRequest from 'admin/scope-change-requests/ScopeChangeRequest'
import ScopeChangeRequestStore from 'admin/ScopeChangeRequestStore'
import ModalViewModel from 'infra/ModalViewModel'
import { action, computed, makeObservable, observable } from 'mobx'
import ScopeChangeRequestRejectOnBehalfOfClientViewModel from '../ScopeChangeRequestRejectOnBehalfOfClientDialog/ScopeChangeRequqestRejectOnBehalfOfClientViewModel'
import { task } from 'mobx-task'

export default class ScopeChangeRequestResolveDialogViewModel extends ModalViewModel {
  @observable scopeChangeRequest = ScopeChangeRequest.none
  @observable resolveAction: 'accept' | 'reject' | 'none' = 'none'

  constructor(
    private scopeChangeRequestStore: ScopeChangeRequestStore,
    private scopeChangeRequestRejectOnBehalfOfClientDialogVM: ScopeChangeRequestRejectOnBehalfOfClientViewModel,
    private refreshStatusFilter: () => Promise<void>,
  ) {
    super()
    makeObservable(this)

    this.close$.subscribe(this.reset)
  }

  /**
   * Checks if the job for the scope change request to be resolved is closed.
   */
  @computed
  get isJobClosed() {
    return this.scopeChangeRequest.job.status === 'CLOSED'
  }

  /**
   * Sets the action to perform
   * @param action
   */
  @action
  setAction(action: 'accept' | 'reject' | 'none') {
    this.resolveAction = action
  }

  /**
   * Opens the dialog
   * @param scopeChangeRequest
   */
  open(scopeChangeRequest: ScopeChangeRequest) {
    this.scopeChangeRequest = scopeChangeRequest
    this.show()
  }

  /**
   * Resets the modal.
   */
  @action.bound
  reset() {
    this.setAction('none')
  }

  /**
   * Resolve the scope change request and close the dialog
   */
  resolve = task.resolved(async () => {
    switch (this.resolveAction) {
      case 'accept':
        await this.scopeChangeRequestStore.acceptScopeChangeRequestOnBehalfOfClient(
          this.scopeChangeRequest,
        )

        await this.refreshStatusFilter()

        return this.close()
      case 'reject':
        this.scopeChangeRequestRejectOnBehalfOfClientDialogVM.open(
          this.scopeChangeRequest,
        )
        return this.close()
      default:
    }
  })
}
